import { Component } from '@angular/core';
import { ColorAnimationService } from '@ethic/shared/color-animation';
import { environment } from '../../environments/environment';

@Component({
  selector: 'lgn-browser-support',
  templateUrl: './browser-support.component.html',
  styleUrls: ['./browser-support.component.scss'],
})
export class BrowserSupportComponent {
  environmentSite = environment.environmentSite;

  constructor(public colorAnimation: ColorAnimationService) {}
}
